import { Popper as AkPopper, type PopperProps as AkPopperProps } from '@atlaskit/popper';

import { wrapComponentForChoreographer } from '../utils';

export const Popper = wrapComponentForChoreographer<AkPopperProps<undefined>>(AkPopper);
